<template>
  <div class="bty">
    <!-- 内容 -->
    <div class="center">
      <div class="by">
        <!-- 推荐列表 -->
        <div class="wrp" v-for="(row,index) in hotList" >
          <div class="hd">
            <div class="dd">{{ row.name }}</div>
            <div class="rr" @click="getlike(row.id)"><a>更多视频</a></div>
          </div>
          <div class="child">
            <div class="item" v-for="(item,indes) in row.list " @click="getDetail(item)">
              <div class="cover">
                <a class="hv">
                  <img :src="item.cover_url" class="ig">
                </a>
              </div>
              <div class="info">
                <div class="tit">{{ item.title }}</div>
                <div class="own">
                  <div class="cv">
                    <img src="@/assets/icon/avt.e4a787f.jpg" class="av">
                    <span class="nm"></span>
                  </div>
                  <div class="cv text-gray">
                    <img src="@/assets/icon/03.png" style="width: 14px; height: 14px;" />
                    <span class="time">{{item.show_count}}</span>
                  </div>
                  <div class="cv text-gray">
                    <img src="@/assets/icon/04.png" style="width: 14px; height: 14px;" />
                    <span class="time" >{{item.created_at}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: 'Home',
  data() {
    return {
      hotList: [],
    };
  },
  created() {
    this.gethot();
  },
  methods: {
// 修改后的getHot方法
    async gethot() {
      try {
        const categoryRes = await api.get('/apiv1/7979vip/categories');
        const arr = await Promise.all(
            categoryRes.data.categories.map(async item => {
              try {
                const list = await this.getList(item.id);
                return {name: item.title, id:item.id, list};
              } catch (err) {
                console.error(`获取${item}失败`, err);
                return {name: item.title,id:item.id, list: []};
              }
            })
        );

        this.hotList = arr;
      } catch (error) {
        console.error('Categories请求失败:', error);
      }
    },

// 修改后的getList方法
    getList(id) {
      const apiUrl = `/apiv1/7979vip/videos?page=1&page_size=10&category=${id}`;
      return api.get(apiUrl)
          .then(res => res.data.videos)
          .catch(error => {
            console.error(`${item}列表获取失败:`, error);
            return []; // 返回空数组防止后续处理崩溃
          });
    },

// /跳转列表
    getlike(id) {
// 定义目标路由信息（可带参数）
      const targetRoute = {
        path: '/list',
        // 可选参数示例：
        query: {categoriesid: id},
      }
// 核心路由跳转逻辑
      if (
          // 检查当前路径是否为/list
          this.$route.path !== '/list' ||
          // 深度比对当前参数与目标值
          this.$route.query.categoriesid != id
      ) {
        this.$router.push(targetRoute)
      }
    },


  //   跳转详情
    getDetail(item){
      var cid = item.id
      // 定义目标路由信息（可带参数）
      const targetRoute = {
        path: '/detail',
        // 可选参数示例：
        query: {cid: cid},
      }
    //判断是否是广告
      if(item.target_type==1){
        // 核心路由跳转逻辑
        if (
            // 检查当前路径是否为/list
            this.$route.path !== '/detail' ||
            // 深度比对当前参数与目标值
            this.$route.query.cid !== cid
        ) {
          this.$router.push(targetRoute)
        }
      }else {
// 跳转外部链接实现
        window.location.href = item.vod_url  // 假设item包含externalUrl字段
      }
    }

  }

}
</script>

<style scoped>

</style>
